import React from "react";

const SellerSummary = ({ seller }) => {
	return (
		<section style={{ marginBottom: "24px" }}>
			<h5 style={{ marginBottom: "8px" }}>Vendedor</h5>
			<div
				style={{
					background: "#f7fafc",
					border: "1px solid #e2e8f0",
					borderRadius: "8px",
					padding: "12px 16px",
				}}
			>
				<div className="grid-x grid-margin-x">
					<div className="cell small-12 medium-3">
						<small>Nombre</small>
						<div>
							<strong>{seller?.nombre || "—"}</strong>
						</div>
					</div>
					<div className="cell small-12 medium-3">
						<small>Correo</small>
						<div>{seller?.correo || "—"}</div>
					</div>
					<div className="cell small-12 medium-3">
						<small>Teléfono</small>
						<div>{seller?.telefono || "—"}</div>
					</div>
					<div className="cell small-12 medium-3">
						<small>Rol</small>
						<div>{seller?.rol || "—"}</div>
					</div>
				</div>
				<p style={{ margin: "8px 0 0", fontSize: "12px", color: "#718096" }}>
					Datos obtenidos del usuario autenticado. No editables en este mockup.
				</p>
			</div>
		</section>
	);
};

export default SellerSummary;
